import { CalendarOutlined } from '@ant-design/icons';
import { DatePicker, type TableColumnType } from 'antd';
import { type FilterDropdownProps } from 'antd/es/table/interface';
import dayjs, { type Dayjs } from 'dayjs';
import React from 'react';

import { COLOR, SPACING } from '../theme/tokens';
import { EDateFormat } from './date-format';
import {
  DEFAULT_DATE_RANGE_PRESETS,
  getDateRangePresetLabel,
  resolveDateRange,
  type TDateRangePreset,
  toPickerValue,
} from './date-range';

const { RangePicker } = DatePicker;

export function getColumnDateRange<T>(): Pick<
  TableColumnType<T>,
  'filterDropdown' | 'filterIcon'
> {
  return {
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }: FilterDropdownProps): React.ReactElement => {
      const now: Dayjs = dayjs();
      const [from, to] = selectedKeys.map(String);

      return (
        <div style={{ padding: SPACING.sm }}>
          <RangePicker
            allowClear
            value={from && to ? [dayjs(from), dayjs(to)] : null}
            presets={DEFAULT_DATE_RANGE_PRESETS.map(
              (preset: TDateRangePreset) => ({
                label: getDateRangePresetLabel(preset, now),
                value: toPickerValue(resolveDateRange(preset, now)),
              }),
            )}
            onChange={(range): void => {
              const [start, end] = range ?? [null, null];

              if (start && end) {
                setSelectedKeys([
                  start.format(EDateFormat.DATE),
                  end.format(EDateFormat.DATE),
                ]);
                confirm();
              } else {
                clearFilters?.({ confirm: true, closeDropdown: true });
              }
            }}
          />
        </div>
      );
    },
    filterIcon: (filtered: boolean): React.ReactElement => (
      <CalendarOutlined
        style={{ color: filtered ? COLOR.primary : undefined }}
      />
    ),
  };
}
